module.exports = __webpack_public_path__ + "static/ProfessionalsCarousel3-0ca122ebb12f70d2902b0cb7347552e0.jpg";